import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Photo } from 'src/app/model/installation/photos.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';


@Component({
  selector: 'app-installation-photos',
  templateUrl: './installation-photos.component.html',
  styleUrls: ['./installation-photos.component.scss']
})
export class InstallationPhotosComponent implements OnInit {

  @Input() installation : any;

  constructor( private service : InstallationsService ) { }
  public photos : Photo[] = [];
  public documents : Photo[] = [];
  ngOnInit(): void {

     if (this.installation) {
       this.service.getPhotosData(this.installation.id_installation)
       .subscribe( (photos) => {
          photos.photos.forEach((photo) => {
            this.setInArrayFromExtension( photo );
          })
       })
     }
  }

  setInArrayFromExtension(photo: Photo) {
    let fileExtension = photo.filename.split('.')[1];
      
    if( fileExtension == 'jpg' || fileExtension == 'jpeg'|| fileExtension == 'png' ){
      this.photos.push(photo);
    } else {
      this.documents.push ( photo );
    }
  }

}
